/* eslint-disable */
export function formatReceiveAllRewardsToast(res = {}) {
  const dailyDays = res.dailyDayIndexList || []
  const accumCodes = res.accumulateRewardCodeList || []
  const props = res.activityPropList || []

  if (!dailyDays.length && !accumCodes.length) {
    return '暂无可领取的奖励'
  }

  const parts = []
  if (dailyDays.length) {
    parts.push(`每日奖励第${dailyDays.join('、')}天`)
  }
  if (accumCodes.length) {
    parts.push(`累充奖励${accumCodes.length}档`)
  }
  if (props.length) {
    const propText = props.map((item) => `${item.propId}x${item.count}`).join('、')
    parts.push(`活动道具：${propText}`)
  }
  return `领取成功：${parts.join('，')}`
}

export function formatPropList(res = {}, dailyRewardConfigList = []) {
  res = JSON.parse(JSON.stringify(res))
  dailyRewardConfigList = JSON.parse(JSON.stringify(dailyRewardConfigList))

  const result = res.activityPropList || []
  res.dailyDayIndexList && res.dailyDayIndexList.forEach((dayIndex) => {
    const config = dailyRewardConfigList.find((item) => item.dayIndex === dayIndex)
    if (!config) {
      return
    }
    result.push(...config.gameProps)
  })
  result.sort((a, b) => {
    return a.propType - b.propType
  })
  return result
}